import { Subject } from 'rxjs';

export const PhoneVerificationSubject = new Subject();
